import {
  StepsFlowBox,
  Step,
  Circle,
  StepText,
  CheckedStep,
} from "./StyledComponents";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ROUTES_PATH } from "../../constants";

export const StepsFlow = () => {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState<string>("");

  const getLocationStep = () => {
    switch (location.pathname) {
      case ROUTES_PATH.ENTRY:
      case ROUTES_PATH.ENTRY_SUS:
      case ROUTES_PATH.CONTINUATION:
        setCurrentStep("1");
        break;
      case ROUTES_PATH.PERSONAL_DATA:
      case ROUTES_PATH.LABOR_DATA:
      case ROUTES_PATH.OCR:
      case ROUTES_PATH.OPERATION_SHIPPING:
      case ROUTES_PATH.PAYMENT:
      case ROUTES_PATH.EXISTING_PAYMENT:
      case ROUTES_PATH.PERSONAL_FINANCES:
        setCurrentStep("2");
        break;
      case ROUTES_PATH.SIGNATURE:
        setCurrentStep("3");
        break;
      case ROUTES_PATH.QUIT:
      case ROUTES_PATH.TIMEOUT:
      case ROUTES_PATH.UNPROCESSABLE:
      case ROUTES_PATH.END:
      case ROUTES_PATH.DENIAL:
      case ROUTES_PATH.UNKNOWN_ERROR:
      case ROUTES_PATH.EXISTING_RFN:
      default:
        setCurrentStep("");
        break;
    }
  };

  // useEffect(() => {
  //     InsightService.logTrace('FlowStep', [{
  //         step: currentStep
  //     }]);
  // }, [currentStep])

  useEffect(() => {
    getLocationStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      {currentStep && (
        <StepsFlowBox>
          <Step>
            <Circle $active={currentStep === "1" ? "isActive" : ""}>
              {currentStep === "2" || currentStep === "3" ? (
                <CheckedStep />
              ) : (
                "1"
              )}
            </Circle>
            <StepText $active={currentStep === "1" ? "isActive" : ""}>
              Plan de pago
            </StepText>
          </Step>
          <Step>
            <Circle $active={currentStep === "2" ? "isActive" : ""}>
              {currentStep === "3" ? <CheckedStep /> : "2"}
            </Circle>
            <StepText $active={currentStep === "2" ? "isActive" : ""}>
              Contratación
            </StepText>
          </Step>
          <Step>
            <Circle $active={currentStep === "3" ? "isActive" : ""}>3</Circle>
            <StepText $active={currentStep === "3" ? "isActive" : ""}>
              Firma electrónica
            </StepText>
          </Step>
        </StepsFlowBox>
      )}
    </>
  );
};

export default StepsFlow;
